// 运营下载页
export default [
  {
    path: '/jkh/download/sms',
    name: 'jkh_download_sms',
    component: () => import('@/pages/activity/download/jkh/sms-download'),
    meta: { title: '下载金可花' }
  },
  // 站外公共下载页
  {
    path: '/download/publicloading',
    name: 'download_publicloading',
    component: () => import('@/pages/activity/download/public-loading'),
    meta: { title: '下载APP' }
  },
  // 站外公共下载页
  {
    path: '/download/test',
    name: 'download_test',
    component: () => import('@/pages/activity/download/test'),
    meta: { title: '测试活动落地页' }
  },
  {
    path: '/wx/welfaredownload',
    name: 'download_welfare',
    component: () => import('@/pages/activity/download/welfare'),
    meta: { title: '老客福利社' }
  },
  // 微信下载落地页
  {
    path: '/wxtemplate/download',
    name: 'download_template',
    component: () => import('@/pages/activity/download/template'),
    meta: { title: '下载易借' }
  },
  // 短信推广下载落地页
  {
    path: '/download/sms',
    name: 'download_sms',
    component: () => import('@/pages/activity/download/sms'),
    meta: { title: '下载易借' }
  },
  // 短信推广小程序落地页
  {
    path: '/download/sms/minprogram',
    name: 'download_sms_minprogram',
    component: () => import('@/pages/activity/download/sms-min-program'),
    meta: { title: '下载易借' }
  },
  // 洋钱罐半流程落地页
  {
    path: '/download/semiprocess',
    name: 'download_semiprocess',
    component: () => import('@/pages/activity/download/semi-process'),
    meta: { title: '下载易借' }
  }
]
